import React from 'react';
import { Link } from 'react-router-dom';
import './NotFoundPage.css';

const NotFoundPage: React.FC = () => {
  return (
    <div className="not-found-page">
      <div className="not-found-content">
        <h1 className="not-found-title">404</h1>
        <h2>Page Not Found</h2>
        <p>
          Sorry, we couldn't find the page you're looking for.
          It might have been moved or doesn't exist.
        </p>
        <div className="not-found-actions">
          <Link to="/" className="btn btn-primary">
            Go to Home Page
          </Link>
          <Link to="/trailers" className="btn btn-secondary">
            Browse Trailers
          </Link>
        </div>
        <div className="not-found-links">
          <h3>Popular Pages:</h3>
          <ul>
            <li><Link to="/trailers/aluminum">Aluminum Trailers</Link></li>
            <li><Link to="/trailers/bunk">Bunk Trailers</Link></li>
            <li><Link to="/trailers/roller">Roller Trailers</Link></li>
            <li><Link to="/inventory">View Inventory</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
